const n = {
  Initiate: "INITIATE",
  Auth: "AUTH",
  Capture: "CAPTURE",
  Cancel: "CANCEL",
  Void: "VOID",
  Skip: "SKIP",
  InitiateRefund: "INITIATE_REFUND",
  Refund: "REFUND",
  RefundStandalone: "REFUND_STANDALONE",
  RefundFollowOn: "REFUND_FOLLOW_ON"
};
export {
  n as r
};
//# sourceMappingURL=PaymentEntryType-3fd2705b.mjs.map
